import type { JsonSchema } from "@jsonforms/core";

export interface WwccCardDetails {
  australian_state?: string;
  card_given_name?: string;
  card_additional_name?: string;
  card_family_name?: string;
  has_no_wwcc_card?: boolean;
}

export function withRequiredField(
  schema: JsonSchema,
  objectPath: string,
  fieldName: string
): JsonSchema {
  const objectSchema: JsonSchema = schema.properties?.[objectPath] ?? {};
  const currentRequired = objectSchema.required ?? [];
  if (currentRequired.includes(fieldName)) return schema;
  return {
    ...schema,
    properties: {
      ...schema.properties,
      [objectPath]: {
        ...objectSchema,
        required: [...currentRequired, fieldName],
      },
    },
  } as JsonSchema;
}
